import { useEffect, useState, useRef } from "react";

import { useAsyncConfig } from "../../../../components/organisms/CustomTable";
import { useAppDispatch, useAppSelector } from "../../../../hooks/redux";
import { setSort } from "../../../../redux/reducers/filter";
import { useGetRequests } from "../../../../redux/reduxQuery/requestApi";

export const useGetData = (initialQs = "") => {
  const [dataToFetch, setDataToFetch] = useState(initialQs);
  const dispatch = useAppDispatch();
  const prevSortRef = useRef<string | null>(null);

  useEffect(() => {
    setDataToFetch((prev) => (prev === initialQs ? prev : initialQs));
  }, [initialQs]);
  const pageSize = useAppSelector(
    (state) => state.filter?.requestControl?.pageSize
  );
  const searchParam = useAppSelector(
    (state) => state.filter?.requestControl?.searchParam
  );
  const sort = useAppSelector((state) => state.filter?.requestControl?.sort);

  const getData = useGetRequests(dataToFetch);
  let search: string | undefined = "";
  if (searchParam === undefined || typeof searchParam === "string") {
    search = searchParam;
  } else {
    search = "";
  }

  let [config, refetch] = useAsyncConfig(
    getData,
    Number(pageSize ?? 50),
    search
  );

  useEffect(() => {
    refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataToFetch]);

  const initialSortSet = useRef(false);

  // if there's a sort order in the redux store, let's use it
  // otherwise, let's default to submitted date ascending
  useEffect(() => {
    if (!initialSortSet.current) {
      initialSortSet.current = true;
      if ((sort as any)?.length > 0) {
        config.asyncConfig.onSortingChange(sort as any);
      } else {
        config.asyncConfig.onSortingChange([
          { id: "submittedDate", desc: false },
        ]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Sync sort changes to Redux for persistence
  const currentSort = config?.asyncConfig?.sort;
  useEffect(() => {
    const sortStr = JSON.stringify(currentSort || []);
    if (prevSortRef.current !== sortStr) {
      prevSortRef.current = sortStr;
      dispatch(
        setSort({
          requestControl: {
            sort: currentSort && currentSort.length > 0 ? currentSort : null,
          },
        })
      );
    }
  }, [currentSort, dispatch]);

  return {
    config,
    refetch,
    dataToFetch,
    setDataToFetch,
  };
};
